<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h4 class="card-title">
        Post Terjadwal
        <span class="badge bg-inverse-success ml-2">{{rows.length}}</span>
      </h4>
      <template v-if="loading">
        <Skeleton :count="1" height="100px" />
      </template>
      <template v-if="rows.length > 0">
        <template v-for="(row, index) in rows" >
          <div class="leave-info-box" :key="index">
            <div class="media align-items-center">
              <div class="media-body">
                <div class="text-sm my-0">
                  <span>{{ row.title }}</span>
                </div>
              </div>
            </div>
            <div class="row align-items-center mt-3">
              <div class="col-6">
                <h6 class="mb-0">
                  <template v-if="row.is_recurring === '1'">
                    <i class="fa fa-clock-o"></i>
                    {{row.recurrence}}
                    <span>
                      <br />
                      time: {{formatHourFromUnix(convertUTCDatetimeToUnix(row.recurrence_time))}}
                    </span>
                    <span v-if="row.recurrence!='daily'">
                      <br />
                      every: {{row.recurrence_every}} {{row.recurrence_annually_month}}
                    </span>

                    <br />end:
                    <span v-if="row.recurrence_end=='never'">{{row.recurrence_end}}</span>
                    <span v-else>{{formatLocalDate(row.recurrence_end_date)}}</span>
                  </template>
                  <template v-else>
                    <h6>{{formatLocalDateWithDay(row.sending_schedule)}}</h6>
                  </template>
                </h6>
                <span class="text-sm text-muted">{{ row.is_recurring === '1' ? 'Recurring' : 'Scheduled' }}</span>
              </div>
              <div class="col-6 text-right">
                <span class="badge bg-inverse-success">Active</span>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="rows.length <= 0 && !loading">
        <div class="no-data__content text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
            height="50px"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
            />
          </svg>
          <h3 class="m-0">Oops!</h3>
          <p class="m-0">Tidak ada data yang tersedia</p>
        </div>
      </template>
      <!---->
    </div>
    <div class="card-footer load-more text-center">
      <router-link v-if="rows.length > 0" :to="{name : 'instagram_post_schedule', query: { scheduled : true} }">Lihat Post Terjadwal</router-link>
      <router-link v-else :to="{name : 'instagram_post_wizard' }">Buat Post Baru</router-link>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import {
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo,
  marketplaceLabelFilter,
  formatLocalDateWithDay,
  formatHourFromUnix,
  convertUTCDatetimeToUnix,
  currentDateTimeUnix
} from "@/utils/helper";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
  },
  data() {
    return {
      linkExcel: "",
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          start_date: "",
          end_date: "",
          mp_product_master_id: "",
          brand_id: "",
          min_price: "",
          max_price: "",
          is_publish: "running",
          is_running: "all"
        },
        page: 1,
        perPage: 10, // perPage
        more_search: false
      }
    };
    //  isactive : true
  },
  computed: {
    formParamSt() {
      return this.$store.state.monitoring.formParamSt;
    },
    isShowForm() {
      return this.$store.state.monitoring.isShowForm;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {},
  created() {
    this.getFirstLastDayInWeek();
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    marketplaceLabelFilter(sortBy, orderBy) {
      return marketplaceLabelFilter(sortBy, orderBy);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },

    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(statusValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to update status " +
          this.selectedTable.length +
          " items to " +
          statusValue +
          "?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "update_status",
              status: statusValue
            };
            this.$store
              .dispatch("monitoring/scrapingActionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Update",
                  text: "The data was successfully updated",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("monitoring/scrapingActionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    monitoringStatusLabel(status) {
      return monitoringStatusLabel(status);
    },
    monitoringStatusLabelStyle(status) {
      return monitoringStatusLabelStyle(status);
    },
    formatDateForMessage(utcDateTime, format) {
      return formatDateForMessage(utcDateTime, format);
    },
    getFirstLastDayInWeek() {
      // let days = getFirstLastDayInWeek();
      // this.serverParams.columnFilters.start_date = this.formatDateForMessage(
      //   days.firstday,
      //   "ISODate"
      // );
      // this.serverParams.columnFilters.end_date = this.formatDateForMessage(
      //   days.lastday,
      //   "ISODate"
      // );
    },
    showSearchForm() {
      this.$store.dispatch("monitoring/setIsShowForm", false);
      this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("search_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowForm", true);
        }
      }, 1000);
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.linkExcel = "";
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      await this.$store.dispatch(
        "monitoring/actFormParamListScrapingSt",
        this.serverParams
      );
    },
    async searchDataMore() {
      this.linkExcel = "";

      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.serverParams = this.formParamSt;
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      // await this.$store.dispatch(
      //   "monitoring/actFormParamSt",
      //   this.serverParams
      // );
    },

    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("instagramSchedule/listSchedule", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading= false
        }); 
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/components/postTerjadwal.vue